exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3L1KYWWo4yj6iTKAzLXwFH{font-size:16px;height:16px;line-height:31px;width:16px}html[dir=ltr] ._3L1KYWWo4yj6iTKAzLXwFH{margin-left:16px;margin-right:12px}html[dir=rtl] ._3L1KYWWo4yj6iTKAzLXwFH{margin-right:16px;margin-left:12px}html[dir] ._2QuIDxJ_h7mEvAQtvwphsv{padding-bottom:16px}html[dir] ._2bgaR3Z4MH9rxsG1FINYr6{padding-bottom:14px}html[dir] ._3dBoK8b3Cxa3T_1dBKTu4s{padding-bottom:16px}", ""]);

// exports
exports.locals = {
	"iconRoot": "_3L1KYWWo4yj6iTKAzLXwFH",
	"iconRootComputer": "_2QuIDxJ_h7mEvAQtvwphsv",
	"iconRootCloud": "_2bgaR3Z4MH9rxsG1FINYr6",
	"iconRootUploadAndShare": "_3dBoK8b3Cxa3T_1dBKTu4s"
};